import React from 'react';
import AuthorWrapper from '../../../components/pages/authorWrapper';

import duonfabeloj from './krivin_duonfabeloj';

const TProzoKrivinContent = (p) => {
	const [action, store] = [p.action, p.store];
	
	return (
		<AuthorWrapper action={action} store={store} itemlist={duonfabeloj}></AuthorWrapper>
	)
}

export default TProzoKrivinContent;